import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgClose = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="m7.87 6.55 5 5 5-5 1.415 1.414-5 5 5 5-1.414 1.414-5-5-5 5-1.414-1.414 5-5-5-5z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgClose);
export default Memo;
